<template>
  <div id="agreementClientCheckBox">
    <instCheckBox :fieldName="'AGREEMENT_ALL'">
      <template v-slot:content>
        <p>Я ознакомлен, понимаю и полностью согласен со следующими <span v-on:click="toggleClientAgreementCheckBox">документами</span>
        </p>
      </template>
    </instCheckBox>

    <div v-show="agreementClientCheckBox">
      <instCheckBox :fieldName="'PROVIDING_MICROLOANS'">
        <template v-slot:content>
          <a target="_blank"
             href="https://finmoll.ru/backend/content/documents/rules_microloans">Правила предоставления микрозаймов</a>
        </template>
      </instCheckBox>
      <instCheckBox :fieldName="'GENERAL_TERMS_OF_MICROLOAN'">
        <template v-slot:content>
          <a href="https://finmoll.ru/backend/content/documents/microloan_terms_conditions" target="_blank">Общие
            условия договора микрозайма</a>
        </template>
      </instCheckBox>
      <instCheckBox :fieldName="'PROCESSING_OF_PERSONAL_DATA'">
        <template v-slot:content>
          <a href="upload/consent_to_PD_processing250721.pdf" target="_blank">Согласие на
            обработку ПД</a>
        </template>
      </instCheckBox>
      <instCheckBox :fieldName="'CONSENT_TO_ADVERTISING'">
        <template v-slot:content>
          <a href="upload/consentToAdvertising250530.pdf" target="_blank">Согласие на
            рекламу</a>
        </template>
      </instCheckBox>

    </div>

  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "instAGREEMENT_ALL",
  data() {
    return {
      agreementClientCheckBox: false
    }
  },
  components: {
    instCheckBox: () => import('@/components/inst/instCheckBox.vue'),
  },
  methods: {
    toggleClientAgreementCheckBox() {
      this.agreementClientCheckBox = !this.agreementClientCheckBox;
    },
    cdAGREEMENT_ALL(value) {
      this.$store.dispatch('saveSendData', {
        target: 'AGREEMENT_ALL',
        value: value
      });
    }
  },
  watch: {
    AGREEMENT_ALL(newValue) {
      console.log('0')
      if (newValue) {
        const fieldList = ['PROVIDING_MICROLOANS', 'GENERAL_TERMS_OF_MICROLOAN', 'PROCESSING_OF_PERSONAL_DATA', 'CONSENT_TO_ADVERTISING'];
        fieldList.forEach((item) => {
          this.$store.dispatch('saveSendData', {
            target: item,
            value: true
          });
        });
      }
    },
    PROVIDING_MICROLOANS(newValue) {
      if (!newValue) {
        this.cdAGREEMENT_ALL(false);
      } else if(this.GENERAL_TERMS_OF_MICROLOAN && this.PROCESSING_OF_PERSONAL_DATA && this.CONSENT_TO_ADVERTISING){
        this.cdAGREEMENT_ALL(true);
      }
    },
    GENERAL_TERMS_OF_MICROLOAN(newValue) {
      if (!newValue) {
        this.cdAGREEMENT_ALL(false);
      } else if(this.PROVIDING_MICROLOANS && this.PROCESSING_OF_PERSONAL_DATA && this.CONSENT_TO_ADVERTISING){
        this.cdAGREEMENT_ALL(true);
      }
    },
    PROCESSING_OF_PERSONAL_DATA(newValue) {
      if (!newValue) {
        this.cdAGREEMENT_ALL(false);
      } else if(this.PROVIDING_MICROLOANS && this.GENERAL_TERMS_OF_MICROLOAN && this.CONSENT_TO_ADVERTISING){
        this.cdAGREEMENT_ALL(true);
      }
    },
    CONSENT_TO_ADVERTISING(newValue) {
      if (!newValue) {
        this.cdAGREEMENT_ALL(false);
      } else if(this.PROVIDING_MICROLOANS && this.PROCESSING_OF_PERSONAL_DATA && this.GENERAL_TERMS_OF_MICROLOAN){
        this.cdAGREEMENT_ALL(true);
      }
    },
  },
  computed: {
    ...mapState({
      AGREEMENT_ALL: state => state.Form.sendData.AGREEMENT_ALL,
      PROVIDING_MICROLOANS: state => state.Form.sendData.PROVIDING_MICROLOANS,
      GENERAL_TERMS_OF_MICROLOAN: state => state.Form.sendData.GENERAL_TERMS_OF_MICROLOAN,
      PROCESSING_OF_PERSONAL_DATA: state => state.Form.sendData.PROCESSING_OF_PERSONAL_DATA,
      CONSENT_TO_ADVERTISING: state => state.Form.sendData.CONSENT_TO_ADVERTISING
    }),
  }
}
</script>

<style scoped>

</style>